import { Drawer } from "@mui/material";
import React, { useEffect, useState } from "react";
import Box from "ReusableComponents/Box";
import Text from "ReusableComponents/Text";
import Logo from "assets/euler_logo.png";
import Close from "assets/close_sidebar.png";
import { COLORS, SIZES } from "theme";
import { useLanguage } from "LanguageContext";
import ArrowDown from "assets/downArrow.svg";
import ArrowDownPrimary from "assets/downarrowPrimary.png";
import { useTranslation } from "react-i18next";
import "../Header/sidebarStyle.css";
import { hiCityHref } from "routes";

const Sidebar = ({ open, onClose, small, language }) => {
    const { t } = useTranslation();
    const { selectedLanguage, setLanguage } = useLanguage();

    const [showDrop, setShowDrop] = useState(false);

    const handleClick = (name) => {
        switch (name) {
            case "hiload":
                return (window.location.href = `/${selectedLanguage}/hiload`);
            case "hicity":
                return (window.location.href = `/${selectedLanguage}/${hiCityHref}`);
            case "book":
                return (window.location.href = `/${selectedLanguage}/book`);
            case "testdrive":
                return (window.location.href = `/${selectedLanguage}/test-ride`);
            case "aboutus":
                return (window.location.href = `/${selectedLanguage}/about-us`);
            case "dealership":
                return (window.location.href = `/${selectedLanguage}/dealership`);
            case "contact":
                return (window.location.href = `/${selectedLanguage}/contact-us`);
            case "blogs":
                return (window.location.href = `/${selectedLanguage}/blogs`);
            case "charging":
                return (window.location.href = `/${selectedLanguage}/charging-network`);
            case "reviews":
                return (window.location.href = `/${selectedLanguage}/product-reviews`);
            case "news":
                return (window.location.href = `/${selectedLanguage}/news`);
            case "career":
                return (window.location.href = `/${selectedLanguage}/career`);
            case "service-network":
                return (window.location.href = `/${selectedLanguage}/service-network`);
            case "showroom-locator":
                return (window.location.href = `/${selectedLanguage}/showroom-locator`);

            default:
                return (window.location.href = `/${selectedLanguage}/`);
        }
    };

    const handleLanguageChange = (event) => {
        const newLanguage = event.toLowerCase();

        setLanguage(newLanguage);
        window.location.reload();
    };
    return (
        <div
            style={{
                position: "fixed",
                top: 0,
                right: 0,
                transform: open ? "translateX(0)" : "translateX(100%)",
                transition: "transform 0.3s",
                backgroundColor: COLORS.lightBlack,
            }}
        >
            <Drawer open={open} onClose={onClose} anchor="right">
                <Box h="inherit" background={COLORS.lightBlack}>
                    <Box
                        display="flex"
                        flexDirection="column"
                        justifyContent="space-between"
                        padding="24px 80px 24px 40px"
                        alignItems="space-between"
                        textAlign="right"
                        h="calc(100vh - 100px)"
                    >
                        <Box
                            display="flex"
                            justifyContent="flex-end"
                            flexDirection="column"
                            alignItems="end"
                        >
                            <Box
                                marginBottom="24px"
                                cursor="pointer"
                                onClick={onClose}
                            >
                                <img src={Close} alt={"close"} width="15px" />
                            </Box>
                            <Box
                                display="flex"
                                alignItems="center"
                                cursor="pointer"
                                padding="8px"
                            >
                                <img
                                    src={Logo}
                                    alt="logo"
                                    height={small && "20px"}
                                />
                            </Box>

                            <Text
                                fontSize={small ? SIZES.twelve : SIZES.sizteen}
                                cursor="pointer"
                                marginTop="10px"
                                className="link"
                                textColor={COLORS.white}
                                onClick={() => handleClick("hiload")}
                            >
                                {t("HiLoad EV")}
                            </Text>
                            <Text
                                fontSize={small ? SIZES.twelve : SIZES.sizteen}
                                cursor="pointer"
                                textColor={COLORS.white}
                                marginTop="10px"
                                className="link"
                                onClick={() => handleClick("book")}
                            >
                                {t("Book Now")}
                            </Text>
                            <Text
                                fontSize={small ? SIZES.twelve : SIZES.sizteen}
                                cursor="pointer"
                                textColor={COLORS.white}
                                marginTop="10px"
                                className="link"
                                onClick={() => handleClick("testdrive")}
                            >
                                Test Ride
                            </Text>
                            <Text
                                fontSize={small ? SIZES.twelve : SIZES.sizteen}
                                cursor="pointer"
                                textColor={COLORS.white}
                                marginTop="10px"
                                className="link"
                                onClick={() => handleClick("charging")}
                            >
                                {t("Charging Network")}
                            </Text>
                            <Text
                                fontSize={small ? SIZES.twelve : SIZES.sizteen}
                                cursor="pointer"
                                className="link"
                                textColor={COLORS.white}
                                onClick={() => handleClick("aboutus")}
                                marginTop="10px"
                            >
                                {t("About Us")}
                            </Text>
                            <Text
                                fontSize={small ? SIZES.twelve : SIZES.sizteen}
                                cursor="pointer"
                                className="link"
                                textColor={COLORS.white}
                                onClick={() => handleClick("career")}
                                marginTop="10px"
                            >
                                {t("Career")}
                            </Text>
                            <Text
                                fontSize={small ? SIZES.twelve : SIZES.sizteen}
                                cursor="pointer"
                                className="link"
                                textColor={COLORS.white}
                                marginTop="10px"
                                onClick={() => handleClick("contact")}
                            >
                                {t("Contact Us")}
                            </Text>
                            <Text
                                fontSize={small ? SIZES.twelve : SIZES.sizteen}
                                cursor="pointer"
                                className="link"
                                textColor={COLORS.white}
                                onClick={() => handleClick("blogs")}
                                marginTop="10px"
                            >
                                {t("Blogs")}
                            </Text>
                            <Text
                                fontSize={small ? SIZES.twelve : SIZES.sizteen}
                                cursor="pointer"
                                className="link"
                                textColor={COLORS.white}
                                onClick={() => handleClick("news")}
                                marginTop="10px"
                            >
                                {t("News")}
                            </Text>
                            <Text
                                fontSize={small ? SIZES.twelve : SIZES.sizteen}
                                cursor="pointer"
                                className="link"
                                textColor={COLORS.white}
                                onClick={() => handleClick("hicity")}
                                marginTop="10px"
                            >
                                {t("Passenger Mobility")}
                            </Text>
                            <Text
                                fontSize={small ? SIZES.twelve : SIZES.sizteen}
                                cursor="pointer"
                                className="link"
                                textColor={COLORS.white}
                                onClick={() => handleClick("reviews")}
                                marginTop="10px"
                            >
                                {t("Product Reviews")}
                            </Text>
                            <Text
                                fontSize={small ? SIZES.twelve : SIZES.sizteen}
                                cursor="pointer"
                                textColor={COLORS.white}
                                className="link"
                                onClick={() => handleClick("dealership")}
                            >
                                {t("Dealership")}
                            </Text>
                            <Text
                                fontSize={small ? SIZES.twelve : SIZES.sizteen}
                                cursor="pointer"
                                className="link"
                                textColor={COLORS.white}
                                onClick={() => handleClick("service-network")}
                            >
                                {t("Service Network")}
                            </Text>
                            <Text
                                fontSize={small ? SIZES.twelve : SIZES.sizteen}
                                cursor="pointer"
                                textColor={COLORS.white}
                                className="link"
                                onClick={() => handleClick("showroom-locator")}
                            >
                                {t("Showroom Locator")}
                            </Text>
                        </Box>
                    </Box>
                </Box>
            </Drawer>
        </div>
    );
};

export default Sidebar;
